import { SUPPORTED_LOCALES } from './locales';

export type Environment = {
  readonly production: boolean;
  readonly version: string;
  readonly baseCurrency: string;
  readonly googleAnalyticsId: string;
  readonly host: string;
  readonly apiPath: string;
  readonly websocketPath: string;
  readonly defaultLocale: string;
  readonly supportedLocales: typeof SUPPORTED_LOCALES;
  readonly loaderProgressColor: string;
  readonly socials: {
    eu: { twitter: string; discord: string; facebook: string };
    pl: { twitter: string; discord: string; facebook: string; instagram: string };
    cis: { youtube: string; discord: string; vk: string; telegram: string }
  };
  readonly sentryDsn: string;
  readonly intercomAppId: string;
  readonly paymentRegionsToHide: number[];
  readonly localesToHide: string[];
  readonly isEuDomain: boolean;
  readonly hotjarSiteId: number;
  readonly cdnPath: string;
  readonly env: 'dev' | 'stage' | 'prod';
};

export const ENVIRONMENT = (_isProduction: boolean): Environment => {
  const EU_DOMAIN = 'cs.fail';
  const isEuDomain = typeof window !== 'undefined' &&
    window.location.href.includes(EU_DOMAIN) &&
    !window.location.href.includes('2cs.fail') &&
    !window.location.href.includes('3cs.fail') &&
    !window.location.href.includes('4cs.fail') &&
    !window.location.href.includes('5cs.fail') &&
    !window.location.href.includes('6cs.fail') &&
    !window.location.href.includes('7cs.fail') &&
    !window.location.href.includes('xcs');
  
  const config = {
    version: '5.0.0',
    host: '6cs.fail', // FOR METATAGS
    defaultLocale: 'ru',
    supportedLocales: SUPPORTED_LOCALES,
    baseCurrency: 'USD',
    loaderProgressColor: '#424c82',
    googleAnalyticsId: 'Z6JKCEZQ75',
    intercomAppId: 'rdr5eia9',
    socials: {
      eu: {
        facebook: 'https://www.facebook.com/csfail2020',
        twitter: 'https://twitter.com/csfail2020',
        discord: 'https://discord.gg/csfail'
      },
      pl: {
        facebook: 'https://www.facebook.com/profile.php?id=61551288476649',
        twitter: 'https://twitter.com/CSFAIL_PL',
        instagram: 'https://www.instagram.com/csfail.pl',
        discord: 'https://discord.gg/csfail'
      },
      cis: {
        vk: 'https://vk.com/cs.fail',
        telegram: 'https://t.me/csfail',
        youtube: 'https://www.youtube.com/c/CSFAIL2020',
        discord: 'https://discord.gg/csfail'
      }
    },
    production: _isProduction,
    websocketPath: '/api/ws',
    apiPath: '/api',
    cdnPath: 'https://cdn.xcs.fail/csfail',
    sentryDsn: 'https://ddea7f7e0efe4d039f223125c4d1c48e@o1399173.ingest.sentry.io/6771468',
    paymentRegionsToHide: [],
    localesToHide: [],
    isEuDomain: false,
    hotjarSiteId: !_isProduction ? 5053119 : (isEuDomain ? 3531972 : 5052897),
    env: 'dev' as 'dev' | 'stage' | 'prod'
  };

  if (isEuDomain) {
    return {
      ...config,
      isEuDomain: true,
      paymentRegionsToHide: [], // [1, 4] | 1 = ru, 4 = belarus
      localesToHide: ['ru']
    };
  }

  return config as Environment;
};
